import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { Card } from '../ui/card';
import { RevenueMix } from '../../types/Reward.api.type';

interface Props {
  mix?: RevenueMix;
  periodLabel: string;
  hasApproximated?: boolean;
  approximatedRatio?: number;
}

const COLORS = ['#3b82f6', '#a855f7'];

export const RevenueMixDonut = ({ mix, periodLabel, hasApproximated, approximatedRatio }: Props) => {
  if (!mix) return null;
  const total = mix.rewardRevenue + mix.interstitialRevenue;
  if (total === 0) {
    return (
      <Card>
        <div className="p-5 text-center text-sm text-gray-500">수익 구성 데이터 없음</div>
      </Card>
    );
  }

  const data = [
    { name: '리워드', value: mix.rewardRevenue },
    { name: '전면', value: mix.interstitialRevenue },
  ];

  return (
    <Card>
      <div className="p-5">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">수익 구성</h3>
        <div className="relative" style={{ height: 240 }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={90}
                paddingAngle={2}
              >
                {data.map((_, idx) => (
                  <Cell key={idx} fill={COLORS[idx]} />
                ))}
              </Pie>
              <Tooltip formatter={(v) => `${Number(v ?? 0).toLocaleString()}원`} />
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
            <div className="text-xs text-gray-500">{periodLabel}</div>
            <div className="text-lg font-bold">{total.toLocaleString()}원</div>
          </div>
        </div>
        <div className="flex justify-center gap-4 mt-3 text-xs">
          <span className="flex items-center gap-1">
            <span className="w-3 h-3 inline-block rounded" style={{ backgroundColor: COLORS[0] }} />
            리워드 {mix.rewardRevenue.toLocaleString()}원
          </span>
          <span className="flex items-center gap-1">
            <span className="w-3 h-3 inline-block rounded" style={{ backgroundColor: COLORS[1] }} />
            전면 {mix.interstitialRevenue.toLocaleString()}원
          </span>
        </div>
        {hasApproximated && (approximatedRatio ?? 0) > 0 && (
          <p className="mt-2 text-xs text-gray-500 text-center">(일부 근사값 포함 — {approximatedRatio}%)</p>
        )}
      </div>
    </Card>
  );
};
